import {analyticsLogEvent} from '../api'

const eventName = 'productDetail'

interface ProductDetailProduct {
    name: string
    id: string
    price: string
    category: string
    variant: string
    color: string
    gender: string
    dimension14: string
    dimension26: string
    callout: string
}

interface Parameters {
    currencyCode: string
    dimension27: string
    product: ProductDetailProduct
}

/**
 * Tracks a productDetail event triggered when the user changes the variation group (color) on the PDP.
 *
 * @param {Parameters} params - Object containing the event parameters.
 * @param {string} params.currencyCode - Currency code of the product.
 * @param {string} params.dimension27 - Whether the product has a vertical video ("true"/"false").
 * @param {ProductDetailProduct} params.product - Product analytics data.
 */
export function analyticsEventProductDetail({currencyCode, dimension27, product}: Parameters): void {
    const eventDetails = {
        ecommerce: {
            currencyCode,
            dimension27,
            detail: {
                products: [product],
            },
        },
    }

    analyticsLogEvent(eventName, eventDetails)
}
